module.exports = __webpack_public_path__ + "img/15.b631f9d0.png";